exports.colors = {
  ACCENT: '#7ad71f',
  ERROR: '#ff6464',
};

exports.keyCodes = {
  ESC: 27,
};
